import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { CalendarCheck, AlertCircle } from 'lucide-react';

const mascara = (v) => {
  const d = String(v || '').replace(/\D/g, '').slice(0, 8);
  return [d.slice(0, 2), d.slice(2, 4), d.slice(4, 8)].filter(Boolean).join('/');
};
const paraIso = (br) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(br || '');
  if (!m) return null;
  const iso = `${m[3]}-${m[2]}-${m[1]}`;
  const dt = new Date(`${iso}T12:00:00`);
  return dt.getDate() === Number(m[1]) && dt.getMonth() + 1 === Number(m[2]) ? iso : null;
};

/** Valida a data de emissão do RPS contra o último RPS do prestador. Retorna mensagem de erro ou null. */
export const erroDataEmissao = (br, emissao) => {
  const iso = paraIso(br);
  if (!iso) return 'Data de emissão inválida (use DD/MM/AAAA).';
  if (emissao?.data_minima && iso < emissao.data_minima)
    return `Data mínima permitida para este prestador: ${emissao.data_minima_br}.`;
  if (emissao?.data_maxima && iso > emissao.data_maxima)
    return `A data de emissão não pode ser futura (máximo ${emissao.data_sugerida_br}).`;
  return null;
};

export const DataEmissaoSegura = ({ emissao, valor, onChange }) => {
  const erro = erroDataEmissao(valor, emissao);
  return (
    <div className="rounded-md border p-3 space-y-2 bg-slate-50" data-testid="previa-data-emissao-box">
      <div className="flex flex-wrap items-end gap-3">
        <div className="space-y-1">
          <Label htmlFor="previa-data-emissao" className="text-xs">Data de emissão</Label>
          <Input id="previa-data-emissao" value={valor} placeholder="DD/MM/AAAA" inputMode="numeric"
            onChange={(e) => onChange(mascara(e.target.value))}
            className={`w-36 ${erro ? 'border-red-500' : ''}`} data-testid="previa-data-emissao-input" />
        </div>
        <div className="text-xs text-slate-600 space-y-0.5">
          <div data-testid="previa-ultimo-rps">
            Último RPS autorizado: {emissao?.ultimo_rps_numero
              ? <b>nº {emissao.ultimo_rps_numero} · {emissao.ultimo_rps_data_br}</b>
              : <b>nenhum registrado</b>}
          </div>
          <div className="text-slate-500">
            {emissao?.prestador_razao_social} · competência não muda a data de emissão
          </div>
        </div>
      </div>
      {erro && (
        <div className="flex flex-wrap items-center gap-2 text-xs text-red-600" data-testid="previa-data-emissao-erro">
          <AlertCircle className="w-4 h-4" /> {erro}
          <Button size="sm" variant="outline" className="h-7"
            onClick={() => onChange(emissao?.data_sugerida_br || '')}
            data-testid="previa-usar-data-segura">
            <CalendarCheck className="w-3.5 h-3.5 mr-1" /> Usar data segura automaticamente
          </Button>
        </div>
      )}
    </div>
  );
};
